---
title: Towards Strategic Reuse in Project-Oriented Environments by Using Software Product Line Practices
slug: towards-strategic-reuse
type: paper
status: published
featured: true
summary: How product-line practices can introduce strategic reuse in organisations that are still structured around projects.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2009-01-01"
lastReviewedAt: "2026-09-18"
audiences:
  - product-developer
  - business
themes:
  - product-lines
sourceUrl: https://ucla.academia.edu/JayvanZyl
originalAuthor: Jay van Zyl
sourceRelationship: academic record listed on Academia.edu
rightsStatus: outbound-only
seoDescription: 2009 paper by Jay van Zyl on strategic reuse in project-oriented environments.
canonicalPath: /research/towards-strategic-reuse
authors:
  - Jay van Zyl
year: 2009
venue: Working paper / Academia.edu
publicationType: article
citation: "van Zyl, J. (2009). Towards Strategic Reuse in Project-Oriented Environments by Using Software Product Line Practices."
researchTheme: product-line-architecture
recordUrl: https://ucla.academia.edu/JayvanZyl
---

Takeaway: a project-oriented bank or insurer does not become a platform company by renaming the PMO. Strategic reuse is a structural change. Profile listing: [Academia.edu](https://ucla.academia.edu/JayvanZyl).
